// The landing page's waitlist before launch (040_waitlist.sql): the copy in both
// languages and the one shape check, so the form and the database agree.
// The consent sentence is stored with each address, as the record of what the
// visitor agreed to (privacy.html).

export type WaitlistLang = 'en' | 'sv'

export const WAITLIST_COPY: Record<WaitlistLang, {
  label: string; placeholder: string; join: string; consent: string; done: string; invalid: string; busy: string; failed: string
}> = {
  en: {
    label: 'Your email', placeholder: 'you@example.com', join: 'Notify me',
    consent: 'We’ll email you once when Matlist opens. Nothing else, and you can ask us to delete your address at any time.',
    done: 'You’re on the list. We’ll write when Matlist opens.',
    invalid: 'That doesn’t look like an email address.',
    busy: 'A lot of people are joining right now. Try again in a minute.',
    failed: 'That didn’t work. Try again in a moment.',
  },
  sv: {
    label: 'Din e-post', placeholder: 'du@exempel.se', join: 'Meddela mig',
    consent: 'Vi mejlar dig en gång när Matlist öppnar. Inget annat, och du kan när som helst be oss radera adressen.',
    done: 'Du står på listan. Vi hör av oss när Matlist öppnar.',
    invalid: 'Det ser inte ut som en e-postadress.',
    busy: 'Många anmäler sig just nu. Försök igen om en minut.',
    failed: 'Det gick inte. Försök igen om en stund.',
  },
}

/** The same shape the database checks (040): something@something.tld, at most 254 characters. */
export function isEmailLike(email: string): boolean {
  const e = email.trim()
  return e.length <= 254 && /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(e)
}
